module.exports = __webpack_public_path__ + "static/media/Landlord_wName.80b9c2ec.png";